export default {
    data() {
        return {
            perPage: parseInt(this.$route.query.pageSize, 10),
            currentPage: parseInt(this.$route.query.pageNumber, 10),
            searchText: this.$route.query.searchText,
        };
    },
    watch: {
        currentPage(newVal) {
            newVal;
            this.updateUrl();
            this.fetchData();
        },
        perPage(newVal) {
            this.currentPage = 1;
            newVal;
            this.updateUrl();
        },
    },
    methods: {
        updateUrl() {
            const currentQuery = this.$route.query;
            const newQuery = {
                pageNumber: String(this.currentPage),
                pageSize: String(this.perPage),
                ...(!(this.searchText === "" || this.searchText == null)) && {searchText: this.searchText},
            };

            if (
                currentQuery.pageNumber !== newQuery.pageNumber ||
                currentQuery.pageSize !== newQuery.pageSize ||
                currentQuery.searchText !== newQuery.searchText
            ) {
                this.$router.push({
                    path: this.$route.path,
                    query: newQuery,
                }).catch();
            }
        },
        fetchData() {
            // override
        },
        initializePagination() {
            const pageNumber = parseInt(this.$route.query.pageNumber, 10);
            const pageSize = parseInt(this.$route.query.pageSize, 10);
            const searchText = this.$route.query.searchText;

            this.currentPage = isNaN(pageNumber) ? 1 : pageNumber;
            this.perPage = isNaN(pageSize) ? 10 : pageSize;
            this.searchText = searchText || "";

            this.updateUrl();
            this.fetchData();
        },
    },
    async created () {
        await this.initializePagination();
    },
};
